import { render } from "./Benutzerverwaltung.vue?vue&type=template&id=d9dbfe10"
import script from "./Benutzerverwaltung.vue?vue&type=script&lang=js"
export * from "./Benutzerverwaltung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__